var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 809,
    viewBox: "0 0 747 809",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M683.5 592.8L514.8 622.8L373.2 808.2L231.5 622.8L62.8 592.8L89.8 377.5L0.0999756 82.7002L231.5 132.1L373.2 0.299805L514.8 132.1L746.2 82.7002L656.5 377.5L683.5 592.8Z",
    fill: "#7D87C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 396.4C383.638 396.4 392.1 387.938 392.1 377.5C392.1 367.062 383.638 358.6 373.2 358.6C362.762 358.6 354.3 367.062 354.3 377.5C354.3 387.938 362.762 396.4 373.2 396.4Z",
    fill: "#17B7E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 9.2002V377.5L231.5 132.1L373.2 9.2002Z",
    fill: "#CAF4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 0.299805V377.5L514.8 132.1L373.2 0.299805Z",
    fill: "#3C2791"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0999756 82.7002L373.2 377.5H89.8L0.0999756 82.7002Z",
    fill: "#3C2791"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0999756 82.7002L202 242.2L373.2 377.5L231.5 132.1L0.0999756 82.7002Z",
    fill: "#6847BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2 588.4L373.2 377.5L231.5 622.8L116.9 599.4L69.2 588.4Z",
    fill: "#A82BB2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8 592.8L373.2 377.5H89.8L62.8 592.8Z",
    fill: "#6847BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 808.2V377.5L514.8 622.8L373.2 808.2Z",
    fill: "#301872"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 791.4V377.5L231.5 622.8L373.2 791.4Z",
    fill: "#D152D8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M683.5 592.8L373.2 377.5H656.5L683.5 592.8Z",
    fill: "#6847BA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M672.3 585L667.7 500.4L559.7 506.9L672.3 585Z",
    fill: "#E096CE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M683.5 592.8L373.2 377.5L514.8 622.8L683.5 592.8Z",
    fill: "#3C2791"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M733.2 93L373.2 377.5L513.2 134.9L733.2 93Z",
    fill: "#96B5E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M746.2 82.7002L373.2 377.5H656.5L746.2 82.7002Z",
    fill: "#3C2791"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 93.5L139.3 192.7L121.7 112.7L13.8 93.5Z",
    fill: "#E096CE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M640.4 166.3L677.4 308.9L746.2 82.7002L640.4 166.3Z",
    fill: "#301872"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8 251.9L186.6 377.5H92.8L54.8 251.9Z",
    fill: "#C155C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 13.8999L508.1 139.4L511.9 142.9L517 141.8L731.8 96L647 374.5L646.4 376.5L646.7 378.6L672.6 584.6L513.2 612.9L509.4 613.6L507 616.7L373.3 791.7L239.6 616.7L237.2 613.6L233.4 612.9L74 584.6L99.8999 378.6L100.2 376.5L99.6001 374.5L14.8 96L229.6 141.8L234.7 142.9L238.5 139.4L373.2 13.8999ZM373.2 0.299805L231.5 132.1L0.0999756 82.7002L89.8 377.4L62.8 592.8L231.5 622.8L373.2 808.2L514.9 622.8L683.6 592.8L656.6 377.4L746.3 82.7002L514.9 132.1L373.2 0.299805Z",
    fill: "#6847BA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M574.4 602.1L513.1 613L509.3 613.7L506.9 616.8L486.7 643.2L496 647.5L514.8 622.8L572.4 612.6L574.4 602.1Z",
    fill: "#96B5E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M408 46.3999L488 120.8L489.5 108.5L414.9 39.1001L408 46.3999Z",
    fill: "#96B5E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.9 608.6L112.5 591.5L105.7 600.4L201.9 617.5C204.3 614.6 206.6 611.6 208.9 608.6Z",
    fill: "#96B5E2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M710.2 166.6L667.1 308.4L679 303.4L720.8 166.3L710.2 166.6Z",
    fill: "#96B5E2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 342L53.4 223.3L43 223.6L78.7 341L89.5 342Z",
    fill: "#96B5E2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M549.9 259.3L422.3 185.6C407.4 177 390.4 172.4 373.2 172.4C356 172.4 339 177 324.1 185.6L196.5 259.3C186.5 265.1 180.3 275.8 180.3 287.3V358.8C180.3 384.4 190.8 408.9 209.1 426.6V431.8C209.1 468.3 228.7 502.3 260.2 520.5L373.2 585.8L486.2 520.5C518.6 501.8 536.7 468.5 537.3 426.6C555.7 408.8 566.1 384.4 566.1 358.8V287.3C566.1 275.8 559.9 265.1 549.9 259.3Z",
    fill: "#1C1128"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 172.5C390.4 172.5 407.4 177.1 422.3 185.7L549.9 259.4C559.9 265.2 566.1 275.9 566.1 287.4V358.9C566.1 384.5 555.6 409 537.3 426.7C536.7 468.6 518.7 501.9 486.2 520.6L373.2 585.9L260.2 520.6C228.7 502.4 209.1 468.4 209.1 431.9V426.7C190.7 408.9 180.3 384.5 180.3 358.9V287.4C180.3 275.9 186.5 265.1 196.5 259.4L324.1 185.7C338.9 177 355.9 172.5 373.2 172.5ZM373.2 162.5C354.2 162.5 335.5 167.5 319.1 177L191.5 250.7C178.4 258.2 170.3 272.3 170.3 287.4V358.9C170.3 385.6 180.8 411.5 199.1 430.8V431.9C199.1 472 220.6 509.3 255.2 529.2L368.2 594.5L373.2 597.4L378.2 594.5L491.2 529.2C525.7 509.3 545.5 474.5 547.2 430.9C565.6 411.6 576.1 385.5 576.1 358.8V287.3C576.1 272.2 568 258.2 554.9 250.6L427.3 176.9C410.9 167.5 392.2 162.5 373.2 162.5Z",
    fill: "#6847BA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M241.6 277.1L373.1 353L504.6 277.1L403.2 218.6C384.5 207.8 361.6 207.8 342.9 218.6L241.6 277.1Z",
    fill: "#B2E83D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 385.1L218.2 297.9V358.8C218.2 378.9 228.9 397.5 246.3 407.5L247 407.9V431.8C247 454.9 259.2 476.1 279.1 487.6L373.1 541.9L467.1 487.6C487 476.1 499.2 454.9 499.2 424.6V408L499.9 407.6C517.3 397.5 528 379 528 358.9V298L373.2 385.1Z",
    fill: "#6847BA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 385.1V541.9L467.2 487.6C487.1 476.1 499.3 454.9 499.3 424.6V408L500 407.6C517.4 397.5 528.1 379 528.1 358.9V298L373.2 385.1Z",
    fill: "#301872"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M518.1 315.1V358.9C518.1 375.4 509.2 390.7 495 399L494.3 399.4L489.3 402.3V408.1V424.8C489.3 450.1 479.9 468.9 462.2 479.1L373.2 530.5L284.2 479.1C267.5 469.5 257.1 451.4 257.1 432V408V402.2L252.1 399.3L251.4 398.9C237.1 390.7 228.3 375.3 228.3 358.8V315L368.4 393.8L373.3 396.6L378.2 393.8L518.1 315.1ZM528.1 298L373.1 385.2L218.1 298V358.9C218.1 379 228.8 397.6 246.2 407.6L246.9 408V431.9C246.9 455 259.1 476.2 279 487.7L373 542L467 487.7C486.9 476.2 499.1 455 499.1 424.7V408L499.8 407.6C517.2 397.5 527.9 379 527.9 358.9V298H528.1Z",
    fill: "#6847BA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M257 402.2L373.2 467.5V479L257 413.7V402.2Z",
    fill: "#3C2791"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M489.3 402.2L373.2 467.5V479L489.3 413.7V402.2Z",
    fill: "#6847BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M403.3 218.5C394 213.1 383.6 210.4 373.2 210.4V353L504.7 277.1L403.3 218.5Z",
    fill: "#21BA45"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 298L246.9 280.1L373.2 353L499.4 280.1L373.2 298Z",
    fill: "#08843A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M373.2 220.5C382 220.5 390.7 222.8 398.3 227.2L484.7 277.1L373.2 341.5L261.7 277.1L348.1 227.2C355.7 222.8 364.4 220.5 373.2 220.5ZM373.2 210.5C362.8 210.5 352.4 213.2 343.1 218.6L241.7 277.1L373.2 353L504.7 277.1L403.3 218.6C394 213.2 383.6 210.5 373.2 210.5Z",
    fill: "#21BA45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster3);
export default __webpack_public_path__ + "static/media/master-3.5485903c6f464d65bb8d3d529d3ab21e.svg";
export { ForwardRef as ReactComponent };